import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../assets/styles/index.css";
import logoImg from "../../assets/img/logo.svg";
import naver from "../../assets/img/naver.svg";
import facebook from "../../assets/img/facebook.png";
import instagram from "../../assets/img/instagram.png";

function HomeNavbar() {
  const [navbarOpen, setNavbarOpen] = React.useState(false);

  return (
    <div>
      <nav className="fixed top-0 z-50 flex-col flex-wrap items-center justify-between w-full h-20 font-sans bg-white border-b border-gray-200 navbar-expand-lg">
        <div className="container flex flex-wrap items-center justify-between h-20 px-4 mx-auto">
          <div className="relative flex lg:block lg:justify-between">
            <Link
              to="/"
              className="z-20 inline-block leading-relaxed whitespace-nowrap"
            >
              <img src={logoImg} alt="logo" className="h-6" />
            </Link>
          </div>
          <div
            className={
              "lg:flex items-center lg:bg-opacity-0 lg:shadow-none z-50"
            }
          >
            <ul className="z-50 hidden group lg:flex lg:list-none lg:ml-auto">
              <div className="flex h-20 gap-4 text-center">
                <li className="flex items-center justify-center w-36">
                  <Link to="/company" className="flex flex-col items-center">
                    <span className="flex items-center justify-center text-base font-semibold text-center group text-gray-950 hover:text-main">
                      회사 소개
                    </span>
                  </Link>
                  {/* invisible */}
                  <div className="absolute top-0 left-0 flex flex-col justify-center invisible w-full pt-20 pb-10 text-sm text-gray-400 bg-white shadow-md backdrop-blur-sm -z-10 group-hover:visible">
                    <div className="flex justify-center gap-4">
                      <div className="flex-col w-36">
                        <Link to="/company">
                          <p className="mb-2 text-gray-600 hover:text-main">
                            코끼리협동조합
                          </p>
                        </Link>
                        <Link to="/company2">
                          <p className="mb-2 text-gray-600 hover:text-main">
                            팀 소개
                          </p>
                        </Link>
                        <Link to="/company3">
                          <p className="text-gray-600 hover:text-main">연혁</p>
                        </Link>
                      </div>

                      {/* 사업 소개 */}
                      <div className="flex-col w-36">
                        <Link to="/works">
                          <p className="mb-2 text-gray-600 hover:text-main">
                            사업 소개
                          </p>
                        </Link>
                        <Link to="works2">
                          <p className="mb-2 text-gray-600 hover:text-main">
                            지역사회 문제 해결
                          </p>
                        </Link>
                        <Link to="works3">
                          <p className="mb-2 text-gray-600 hover:text-main">
                            메이커 스페이스 운영
                          </p>
                        </Link>
                        <Link to="works4">
                          <p className="text-gray-600 hover:text-main">
                            창업 지원
                          </p>
                        </Link>
                      </div>

                      {/* 커뮤니티 */}
                      <div className="flex-col w-36">
                        <Link to="community">
                          <p className="mb-2 text-gray-600 hover:text-main">
                            공지사항
                          </p>
                        </Link>
                        <Link to="community2">
                          <p className="mb-2 text-gray-600 hover:text-main">
                            활동 소식
                          </p>
                        </Link>
                        <Link to="community3">
                          <p className="text-gray-600 hover:text-main">
                            뉴스레터
                          </p>
                        </Link>
                      </div>

                      {/* 문의 */}
                      <div className="flex-col w-36">
                        <Link to="contact">
                          <p className="mb-2 text-gray-600 hover:text-main">
                            상담 신청
                          </p>
                        </Link>
                        <Link to="contact2">
                          <p className="mb-2 text-gray-600 hover:text-main">
                            FAQ
                          </p>
                        </Link>
                        <Link to="contact3">
                          <p className="text-gray-600 hover:text-main">
                            오시는 길
                          </p>
                        </Link>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="flex items-center justify-center w-36">
                  <Link to="/works">
                    <span className="flex items-center text-base font-semibold text-center text-gray-950 hover:text-main">
                      사업 소개
                    </span>
                  </Link>
                </li>

                <li className="flex items-center justify-center w-36">
                  <Link to="/community">
                    <span className="flex items-center text-base font-semibold text-center text-gray-950 hover:text-main">
                      커뮤니티
                    </span>
                  </Link>
                </li>

                <li className="flex items-center justify-center w-36">
                  <Link to="contact">
                    <span className="flex items-center text-base font-semibold text-center text-gray-950 hover:text-main">
                      문의
                    </span>
                  </Link>
                </li>
              </div>
            </ul>
            <div className="lg:hidden">
              <button
                className="block px-3 py-1 text-xl leading-none bg-transparent border-transparent outline-none cursor-pointer focus:outline-none"
                type="button"
                onClick={() => setNavbarOpen(!navbarOpen)}
              >
                <i className="fas fa-bars" style={{ color: "black" }}></i>
              </button>
            </div>
          </div>
          <div className="hidden lg:items-center lg:justify-center lg:gap-3 lg:flex">
            <Link
              to="https://m.blog.naver.com/PostList.naver?blogId=co77iri"
              className="inline-block leading-relaxed whitespace-nowrap"
            >
              <img src={naver} alt="logo" className="w-6 h-6" />
            </Link>
            <Link
              to="https://www.facebook.com/co77iri/?locale=ko_KR"
              className="inline-block leading-relaxed whitespace-nowrap"
            >
              <img src={facebook} alt="logo" className="w-6 h-6" />
            </Link>
            <Link
              to="https://www.instagram.com/co77iri/"
              className="inline-block leading-relaxed whitespace-nowrap"
            >
              <img src={instagram} alt="logo" className="w-6 h-6" />
            </Link>
          </div>
        </div>
        <div
          className={`absolute flex flex-col justify-center gap-2 text-sm text-center bg-white rounded-md shadow-md right-6 lg:hidden md:right-14 h-36 w-36 ${
            navbarOpen ? "visible" : "invisible"
          }`}
        >
          {" "}
          <Link to="/company">
            <p className="text-gray-950 hover:font-bold">회사 소개</p>
          </Link>
          <p className="text-gray-950 hover:font-bold">사업 소개</p>
          <p className="text-gray-950 hover:font-bold">커뮤니티</p>
          <p className="text-gray-950 hover:font-bold">문의</p>
        </div>
      </nav>
    </div>
  );
}

export default HomeNavbar;
